import axios from 'axios'

var host = process.env.VUE_APP_API_HOST

export const clientServices = {
  getLegal,
  getByUsername,
  getByOwner,
  createClient,
  updateClientSubscription,
  cancelClientSubscription,
  updateClient,
  updateClientSettings,
  getClientPage,
  getClientPageList,
  saveClientPage,
  deleteClientPage,
  getActiveEvents,
  getEvent,
  getModuleMenu,
  saveModuleMenu,
  getEventListSummary,
  getActivityDay,
  saveActivityDay,
  deleteActivityDay,
  getActivity,
  saveActivity,
  deleteActivity,
  saveModule,
  getModule,
  deleteModule,
  postPDT,
  clientExists,
  getSubscriptionPlan,
  getSubscriptionPlans,
  getSubscriptionStatus,
  requestAdministrator,
  getAdministrators,
  removeAdministrator,
  getModuleEmail,
  saveModuleEmail,
  sendModuleEmailTest,
  saveSaleDetail,
  getTemplatesForSale,
  getTemplateForSaleDetail,
  setTemplateForSale,
  cancelTemplateForSale,
  getDayWithActivities,
  saveLiveActivityMenu,
  validateData,
  getReviews,
  deleteImage,
  uploadImage,
  // uploadActivityImage,
  getTemplateSales,
  getTemplateSalesReport,
  getWebhookSubscription,
  deleteWebhookSubscription,
  activateWebhookSubscription,
  getWebhookSubscriptions,
  saveWebhookSubscription,
  sendWebhookTestRequest,
  createApiKey,
  deleteApiKey,
  getApiKeys,
  releaseTwilio,
  addOrUpdateTwilio,
  getTwilio,
  sendTwilioTestMessage,
  addOrUpdateClickSend,
  getClickSend,
  deleteClickSend,
  sendClickSendTestMessage
}

function getLegal (page) {
  return new Promise(function (resolve, reject) {
    axios
      .get(host + '/resources/legal/' + page + '.html')
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

// Gets a Client based upon their client Username.  Used for /portal/-username-
// does NOT get the full client object.  DO NOT use for updating
function getByUsername (username) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.getByUsername(' + username + ')')
    axios
      .get(host + '/api/client/username/' + username)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

// Gets a Client based upon their client Owner.
function getByOwner () {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.getByOwner()')
    axios
      .get(host + '/api/client/byowner')
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function createClient (client) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/client/', client)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function updateClientSubscription (subscription, planId) {
  return new Promise(function (resolve, reject) {
    return axios
      .put(host + '/api/client/subscription',
        {
          subscription: subscription,
          planId: planId
        }
      )
      .then(response => {
        resolve()
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function cancelClientSubscription (subscription) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/client/subscription/' + subscription + '/cancel')
      .then(response => {
        resolve()
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function updateClient (client) {
  return new Promise(function (resolve, reject) {
    return axios
      .put(host + '/api/client/', client)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function updateClientSettings (client) {
  return new Promise(function (resolve, reject) {
    return axios
      .put(host + '/api/client/settings', client)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function getEventListSummary (key) {
  return axios
    .get(host + '/api/client/event/list/all/' + key)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

// Gets events that are active and within the registration period set by the module
function getActiveEvents (clientId) {
  return new Promise(function (resolve, reject) {
    axios
      .get(host + '/api/client/' + clientId + '/events')
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getClientPageList () {
  return new Promise(function (resolve, reject) {
    axios
      .get(`${host}/api/clientpage/list`)
      .then(response => {
        console.log(response.data)
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getClientPage (clientId, pageName) {
  return new Promise(function (resolve, reject) {
    axios
      .get(`${host}/api/clientpage/${clientId}/${pageName}`)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function saveClientPage (clientId, pageName, pageData) {
  return new Promise(function (resolve, reject) {
    axios
      .post(`${host}/api/clientpage/`, {
        clientId: clientId,
        name: pageName,
        pageData: pageData
      })
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function deleteClientPage (pageName) {
  return new Promise(function (resolve, reject) {
    axios
      .delete(`${host}/api/clientpage/${pageName}`)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getEvent (clientId, eventId) {
  return new Promise(function (resolve, reject) {
    axios
      .get(host + '/api/client/' + clientId + '/event/' + eventId)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getModuleMenu (moduleid) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.getModuleMenu(' + moduleid + ')')
    axios
      .get(host + '/api/Module/' + moduleid + '/menu')
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function saveModuleMenu (moduleid, menu) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.saveModuleMenu(' + moduleid + ', menu)')
    axios
      .post(host + '/api/Module/' + moduleid + '/menu', menu)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getActivityDay (id) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.getActivityDay(' + id + ')')
    axios
      .get(host + '/api/Activity/day/' + id)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getDayWithActivities (eventId, activityDayId) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.getDayWithActivities(' + eventId + ')')
    axios
      .get(host + '/api/Event/' + eventId + '/day/' + activityDayId)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function saveActivityDay (activityDay) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.saveActivityDay()')
    axios
      .post(host + '/api/Activity/day/', activityDay)
      .then(response => {
        resolve(response.data)
      }, error => {
        console.log('clientServices.saveActivityDay() => ERROR : ' + JSON.stringify(error))
        reject(error)
      })
  })
}

function deleteActivityDay (id) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.deleteActivityDay(' + id + ')')
    axios
      .delete(host + '/api/Activity/day/' + id)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getActivity (id) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.getActivity(' + id + ')')
    axios
      .get(host + '/api/Activity/' + id)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function saveActivity (activity) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.saveActivity()')
    axios
      .post(host + '/api/Activity/', activity)
      .then(response => {
        console.log('clientServices.saveActivity() => RESPONSE : ' + JSON.stringify(response))
        resolve(response.data)
      }, error => {
        console.log('clientServices.saveActivity() => ERROR : ' + JSON.stringify(error))
        reject(error)
      })
  })
}

function deleteActivity (id) {
  return new Promise(function (resolve, reject) {
    console.log('clientServices.deleteActivity(' + id + ')')
    axios
      .delete(host + '/api/Activity/' + id)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function saveModule (module) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/Module', module)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function getModule (id) {
  return new Promise(function (resolve, reject) {
    axios
      .get(host + '/api/module/' + id)
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function deleteModule (id) {
  return new Promise(function (resolve, reject) {
    axios
      .delete(host + '/api/module/' + id)
      .then(() => {
        resolve()
      }, error => {
        reject(error)
      })
  })
}

function postPDT (pdt) {
  return new Promise(function (resolve, reject) {
    console.log('PDT: ' + pdt)
    return axios
      .post(host + '/api/paypal/pdt', pdt)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('PDT Create Error: ' + JSON.stringify(pdt))
        console.log(err)
        reject(err)
      })
  })
}

function clientExists (username) {
  console.log('Attempting clientExists')
  return axios
    .get(host + '/api/client/exists/' + username)
    .then(response => {
      console.log('clientExists: ' + JSON.stringify(response.data))
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getSubscriptionPlan () {
  return axios
    .get(host + '/api/client/subscription/plan')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getSubscriptionPlans () {
  return axios
    .get(host + '/api/client/subscription/plans')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getSubscriptionStatus () {
  return axios
    .get(host + '/api/client/subscription/status')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function requestAdministrator (email) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting clientServices.requestAdministrator: ' + email)
    axios
      .post(host + '/api/client/admin/request', { email })
      .then(resp => {
        console.log('clientServices.requestAdministrator: ' + JSON.stringify(resp))
        if (resp.response) {
          console.log('requestAdministrator response:' + JSON.stringify(resp.response))
          resolve()
        } else {
          resolve()
        }
      }, error => {
        console.log('clientServices.requestAdministrator error: ' + JSON.stringify(error))
        if (error.response) {
          console.log('requestAdministrator error response:' + JSON.stringify(error.response))
          reject(error.response.data)
        } else {
          reject(error)
        }
      })
  })
}

function getAdministrators () {
  return axios
    .get(host + '/api/client/admin/list')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function removeAdministrator (id) {
  return axios
    .get(host + '/api/client/admin/remove/' + id)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function saveModuleEmail (moduleEmail) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/module/email/', moduleEmail)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        console.log('Module Send Email Error')
        console.log(err)
        reject(err.response)
      })
  })
}

function getModuleEmail (moduleId, emailType) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(`${host}/api/module/${moduleId}/email/${emailType}`)
      .then(response => {
        return resolve(response.data)
      })
      .catch(err => {
        console.log('Get Module Email Error')
        console.log(err)
        reject(err.response)
      })
  })
}

function sendModuleEmailTest (moduleEmail) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/module/email/test', moduleEmail)
      .then(response => {
        resolve()
      })
      .catch(err => {
        console.log('Module Send Email Error')
        console.log(err)
        reject(err.response)
      })
  })
}

function saveSaleDetail (saleDetail) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/module/saledetail', saleDetail)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        console.log('Module Save Sale Detail Error')
        console.log(err)
        reject(err.response)
      })
  })
}

// Gets a list of templates that the current client is selling
function getTemplatesForSale () {
  console.log('Attempting getTemplatesForSale()')
  return axios
    .get(host + '/api/client/module/forsale')
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

// Gets a Template that the current client is selling
function getTemplateForSaleDetail (id) {
  console.log('Attempting getTemplateForSaleDetail()')
  return axios
    .get(host + '/api/client/module/forsale/' + id)
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function setTemplateForSale (templateDetail) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/module/forsale', templateDetail)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        console.log('Module setTemplateForSale Error')
        console.log(err)
        reject(err.response)
      })
  })
}

function cancelTemplateForSale (id) {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + '/api/module/saledetail/' + id)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        console.log('Module cancelTemplateForSale Error')
        console.log(err)
        reject(err.response)
      })
  })
}

function saveLiveActivityMenu (id, activities) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/activity/menu/live/' + id, activities)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function validateData (eventId, activityDayId, activityId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/Event/validate/' + eventId + '/dayid/' + activityDayId + '/activityid/' + activityId)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function getReviews () {
  return axios
    .get(host + '/api/client/reviews')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function deleteImage (imgPath) {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + `/api/image/`,
        {
          params: { img: imgPath }
        })
      .then(response => {
        return resolve(response)
      // return response
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function uploadImage (formData) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + `/api/image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

// function uploadActivityImage (activityId, moduleId, formData) {
//   return new Promise(function (resolve, reject) {
//     return axios
//       .post(host + `/api/Activity/${activityId}/module/${moduleId}/image/`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       })
//       .then(response => {
//         return resolve(response)
//       })
//       .catch(err => {
//         reject(err.response)
//       })
//   })
// }

function getTemplateSales (orderby, direction, pageNumber) {
  console.log('Attempting getTemplateSales()')
  return axios
    .get(host + `/api/client/module/sales/${orderby}/${pageNumber}?sort=${direction}`)
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function getTemplateSalesReport () {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/client/module/sales/report')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function getWebhookSubscription (id) {
  console.log('Attempting GetWebhookSubscription(' + id + ')')
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/webhooks/subscriptions/' + id)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function getWebhookSubscriptions () {
  console.log('Attempting GetWebhookSubscriptions()')
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/webhooks/subscriptions')
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function deleteWebhookSubscription (id) {
  console.log('Attempting DeleteWebhookSubscription(' + id + ')')
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + '/api/webhooks/subscriptions/' + id)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function activateWebhookSubscription (id, active) {
  console.log('Attempting ActivateWebhookSubscription(' + id + ')')
  return new Promise(function (resolve, reject) {
    return axios
      .put(host + `/api/webhooks/subscriptions/${id}/active/${active}`)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function saveWebhookSubscription (webhookSubscription) {
  console.log('Attempting SaveWebhookSubscriptions()')
  console.log('Saving: ' + JSON.stringify(webhookSubscription))
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/webhooks/subscriptions', webhookSubscription)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function sendWebhookTestRequest (webhook, subscriptionId) {
  console.log('Attempting sendWebhookTestRequest()')
  var request = {
    webhook: webhook
  }
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + `/api/webhooks/subscriptions/${subscriptionId}/test`, request)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function createApiKey () {
  console.log('Attempting createApiKey()')
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + `/api/webhooks/apikeys`)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function deleteApiKey (key) {
  console.log('Attempting deleteApiKey()')
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + `/api/webhooks/apikeys?key=${key}`)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function getApiKeys () {
  console.log('Attempting getApiKeys()')
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + `/api/webhooks/apikeys`)
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}

function addOrUpdateTwilio (twilio) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/twilio', twilio)
      .then(() => {
        resolve()
      })
      .catch(err => {
        console.log('Twilio Add/Update Error: ' + JSON.stringify(twilio))
        console.log(err)
        reject(err)
      })
  })
}

function sendTwilioTestMessage (data) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/twilio/send', data)
      .then(() => {
        resolve()
      })
      .catch(err => {
        console.log('Twilio Send Error: ' + JSON.stringify(data))
        console.log(err)
        reject(err)
      })
  })
}

function releaseTwilio (twilio) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/twilio/release', twilio)
      .then(() => {
        resolve()
      })
      .catch(err => {
        console.log('Twilio Create Error: ' + JSON.stringify(twilio))
        console.log(err)
        reject(err)
      })
  })
}

function getTwilio () {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/twilio')
      .then((result) => {
        resolve(result)
      })
      .catch(err => {
        console.log('Twilio Get Error')
        console.log(err)
        reject(err)
      })
  })
}

function addOrUpdateClickSend (clickSend) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/clicksend', clickSend)
      .then(() => {
        resolve()
      })
      .catch(err => {
        console.log('ClickSend Add/Update Error: ' + JSON.stringify(clickSend))
        console.log(err)
        reject(err)
      })
  })
}

function sendClickSendTestMessage (data) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/clicksend/send', data)
      .then(() => {
        resolve()
      })
      .catch(err => {
        console.log('ClickSend Send Error: ' + JSON.stringify(data))
        console.log(err)
        reject(err)
      })
  })
}

function deleteClickSend () {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + '/api/clickSend')
      .then((result) => {
        resolve(result)
      })
      .catch(err => {
        console.log('ClickSend Get Error')
        console.log(err)
        reject(err)
      })
  })
}

function getClickSend () {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/clickSend')
      .then((result) => {
        resolve(result)
      })
      .catch(err => {
        console.log('ClickSend Get Error')
        console.log(err)
        reject(err)
      })
  })
}
